module.exports = __webpack_public_path__ + "img/lupa.fd10c6a2.svg";